import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const NumberGrid = ({ numbers, subtitles }) => {
    return (
        <Container style={{ margin: '0 auto' }}>
            <Row className="justify-content-center">
                {numbers.map((number, index) => (
                    <Col key={index} className="text-center">
                        <div className="number" style={{ color: '#28588F', fontSize: '4rem' }}>{number}</div>
                        <div className="subtitle" style={{ fontSize: '1.4rem' }}>{subtitles[index]}</div>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default NumberGrid;
